import { i18, trb } from '../../../../../Utilities';
import { FormField, Input } from 'src/shared';

export const FieldBIC = () => {
  return (
    <FormField
      name="Payment.BIC"
      label={trb(i18.Labels.BIC)}
    >
      <Input />
    </FormField>
  );
};
